module.exports = __webpack_public_path__ + "media/site_templates/www.cheaptaxaccountants.com.au/images/our_services_2-b9c05e1a7d52344c11e4c13549a57d05.jpg";